import styled from 'styled-components'

const Col = styled.div`
  width: 160px;
`

export const s = { Col }
